import {
  rankWith,
  ControlProps,
  isDateControl,
} from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { DateShortcutField } from '../DateShortcutField';
import { FieldLabel } from '../FieldLabel';

/**
 * Tester function to determine if this renderer should be used for date fields
 */
export const dateRendererTester = rankWith(
  15, // Higher than default Material-UI renderers (1-2) but lower than lookups (20)
  isDateControl
);

/**
 * Date renderer component with F&O-style keyboard shortcuts
 *
 * Supports:
 * - `t` or `T` → today's date
 * - `+N` / `-N` → relative day offsets
 * - `D` or `DD` → day in current month
 * - `MMDD` → month + day (nearest date rule)
 * - `YYMMDD` → year + month + day
 * - Standard formats: YYYY-MM-DD, YYYYMMDD, DD/MM, DD/MM/YYYY
 */
export const DateRendererComponent = (props: ControlProps) => {
  const { data, handleChange, path, label, description, required, errors, enabled, visible } = props;

  if (!visible) {
    return null;
  }

  return (
    <DateShortcutField
      value={data}
      onChange={(value) => handleChange(path, value)}
      label={<FieldLabel label={label} description={description} />}
      required={required}
      disabled={!enabled}
      error={errors || undefined}
    />
  );
};

/**
 * Connected date renderer with JSON Forms props
 */
export const DateRenderer = withJsonFormsControlProps(DateRendererComponent);

/**
 * Renderer entry for JSON Forms
 */
export const dateRendererEntry = {
  tester: dateRendererTester,
  renderer: DateRenderer,
};
